import moment from "moment";

export const DEFAULT_INPUT_FORMAT = "HH:mm";
export const DEFAULT_OUTPUT_FORMAT = "h:mm A";

/**
 * Format a time string using moment.
 *
 * @param {Object} options
 * @param {string} options.time - The time value to format (required).
 * @param {string} [options.inputFormat="HH:mm"] - The format of the input time string.
 * @param {string} [options.outputFormat="h:mm A"] - The desired output format.
 * @returns {string} Formatted time, or empty string if input is invalid/missing.
 *
 * @example
 * formatTime({ time: "13:00" }); // "1:00 PM"
 * formatTime({ time: "13:00", outputFormat: "HH:mm" }); // "13:00"
 */
export const formatTime = ({
  time,
  inputFormat = DEFAULT_INPUT_FORMAT,
  outputFormat = DEFAULT_OUTPUT_FORMAT,
} = {}) => {
  if (!time) return "";
  const parsed = moment(time, inputFormat, true);
  if (!parsed.isValid()) return "";
  return parsed.format(outputFormat);
};
